/* eslint-disable @typescript-eslint/no-unused-expressions */
import axios from "axios"
import { decode } from "geobuf"
import Pbf from "pbf"
import { provincesReplace } from "@/constants/constant"
import { getProvinceCodeByCity } from "@/util/commonUtils"

/**
 * 根据省市区code获取geojson数据
 * @param code
 * @returns
 */
const geoJsonMap = new Map()
export function getGeojsonByCode(
  areaCode: string | number,
): Promise<GeoJSON.FeatureCollection | GeoJSON.Feature> {
  const reg = /(0000|00)$/
  const codeValues = Object.values(provincesReplace)
  // 如果areaCode是直辖市，则将areaCode替换为对应的省code
  const code = codeValues.includes(Number(areaCode)) ? getProvinceCodeByCity(areaCode) : areaCode
  let _code = `${code}`
  const isDistrict = !reg.test(_code)
  if (isDistrict) {
    // 直辖市下的区县特殊处理
    const codeHeaders = Object.keys(provincesReplace).map((v) => `${v}`.slice(0, 2))
    if (codeHeaders.includes(_code.slice(0, 2))) {
      _code = `${_code.slice(0, 2)}0000`
    } else {
      _code = `${_code.slice(0, 4)}00`
    }
  }

  return new Promise((resolve) => {
    if (geoJsonMap.has(`${code}`)) {
      resolve(geoJsonMap.get(`${code}`))
      return
    }
    axios.get(`/geobuf/${_code}.pbf`, { responseType: "arraybuffer" }).then((result) => {
      const geojson = decode(new Pbf(result.data))
      geoJsonMap.set(_code, geojson)
      if (isDistrict) {
        geojson.features.forEach(
          (gj: GeoJSON.Feature<GeoJSON.Polygon | GeoJSON.MultiPolygon, any>) => {
            const { adcode } = gj.properties
            if (adcode) {
              geoJsonMap.set(`${adcode}`, gj)
            }
          },
        )
      }
      resolve(geoJsonMap.get(`${code}`))
    })
  })
}

/**
 * 根据code获取全国或省市区的经纬度
 */
export async function getPosition(code: string | number) {
  try {
    const geo: any = await getGeojsonByCode(code)

    if (!geo?.properties) {
      return null
    }
    const { center = [] } = geo.properties
    const [lng, lat] = center

    return {
      longitude: lng,
      latitude: lat,
    }
  } catch (error) {
    throw error
  }
}
